import React__default from 'react';
import PropTypes from 'prop-types';
import { CardBody as CardBody$2, ContentWrapper } from './Card.styles.js';
import STATUS_FEEDBACK_TYPES from '../Status/status.constants.js';
import StatusBase from '../Status/StatusBase.js';

var CardBody = function CardBody(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId,
    _ref$statusType = _ref.statusType,
    statusType = _ref$statusType === void 0 ? undefined : _ref$statusType,
    _ref$statusTitle = _ref.statusTitle,
    statusTitle = _ref$statusTitle === void 0 ? undefined : _ref$statusTitle,
    _ref$statusDescriptio = _ref.statusDescription,
    statusDescription = _ref$statusDescriptio === void 0 ? undefined : _ref$statusDescriptio,
    _ref$statusButtonProp = _ref.statusButtonProps,
    statusButtonProps = _ref$statusButtonProp === void 0 ? undefined : _ref$statusButtonProp;
  var hasStatus = statusType && statusTitle && statusDescription;
  return React__default.createElement(CardBody$2, {
    "data-testid": testId
  }, React__default.createElement(ContentWrapper, {
    $hasStatus: hasStatus
  }, children), hasStatus && React__default.createElement(StatusBase, {
    type: statusType,
    title: statusTitle,
    buttonProps: statusButtonProps
  }, statusDescription));
};
CardBody.propTypes = {
  children: PropTypes.node,
  statusButtonProps: PropTypes.objectOf(StatusBase.propTypes.buttonProps),
  statusDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  statusTitle: PropTypes.string,
  statusType: PropTypes.oneOf(Object.values(STATUS_FEEDBACK_TYPES)),
  testId: PropTypes.string
};
var CardBody$1 = CardBody;

export { CardBody$1 as default };
//# sourceMappingURL=CardBody.js.map
